import React from "react";
import { Table } from "react-bootstrap";

import { ICRTableData } from "../../config/interfaces";
import PriceDisplay from "../PriceDisplay";

type Props = {
	CRTableData: ICRTableData;
};

const CompareRegimesTable: React.FC<Props> = (props: Props) => {
	const {
		GrossTotIncome,
		newRegimeDeductions,
		oldRegimeDeductions,
		newRegimePayable,
		oldRegimePayable,
		newTaxableIncome,
		oldTaxableIncome,
		newBalTaxPayable,
		oldBalTaxPayable,
		newTotalTaxPaid,
		oldTotalTaxPaid
	} = props.CRTableData;

	return (
		<Table responsive={true} striped={true} className="mb-0">
			<thead>
				<tr>
					<th className="cell-min-200"></th>
					<th className="cell-min-180 fw-medium">New Regime</th>
					<th className="cell-min-180 fw-medium">Old Regime</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>A. Gross Total Income</td>
					<td>
						<PriceDisplay price={GrossTotIncome} />
					</td>
					<td>
						<PriceDisplay price={GrossTotIncome} />
					</td>
				</tr>
				<tr>
					<td>B. Tax Saving Deductions</td>
					<td>
						<PriceDisplay price={newRegimeDeductions} />
					</td>
					<td>
						<PriceDisplay price={oldRegimeDeductions} />
					</td>
				</tr>
				<tr>
					<td>C. Total Taxable Income (A - B)</td>
					<td>
						<PriceDisplay price={newTaxableIncome} />
					</td>
					<td>
						<PriceDisplay price={oldTaxableIncome} />
					</td>
				</tr>
				<tr>
					<td>D. Total Tax Payable</td>
					<td>
						<PriceDisplay price={newRegimePayable} />
					</td>
					<td>
						<PriceDisplay price={oldRegimePayable} />
					</td>
				</tr>
				<tr>
					<td>E. Total Tax Paid</td>
					<td>
						<PriceDisplay price={newTotalTaxPaid} />
					</td>
					<td>
						<PriceDisplay price={oldTotalTaxPaid} />
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th className="fw-medium">Taxes Due or Refund (D - E)</th>
					<th className="fw-medium">
						{newBalTaxPayable < 0 ? (
							<>
								None (
								<PriceDisplay price={newBalTaxPayable} /> Refund)
							</>
						) : (
							<>
								{newBalTaxPayable > 0 ? (
									<PriceDisplay price={newBalTaxPayable} />
								) : (
									<PriceDisplay price={0} />
								)}
							</>
						)}
					</th>
					<th className="fw-medium">
						{oldBalTaxPayable < 0 ? (
							<>
								None (
								<PriceDisplay price={oldBalTaxPayable} /> Refund)
							</>
						) : (
							<>
								{oldBalTaxPayable > 0 ? (
									<PriceDisplay price={oldBalTaxPayable} />
								) : (
									<PriceDisplay price={0} />
								)}
							</>
						)}
					</th>
				</tr>
			</tfoot>
		</Table>
	);
};

export default CompareRegimesTable;
